import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Sales by Customer";
const description = `The "Sales by Customer" report is a system that provides a historical record of what each customer has purchased. This report allows a business to track a customer's entire buying history, showing specific items, quantities, and dates of past transactions. It is a fundamental tool for understanding customer behavior and sales patterns.`;

const images = [
    '/images/reports/sales/sales-by-customer/sales-by-customer.png', // 0
];


const SalesByCustomer: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesByCustomer;
